
namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class StockReportGrid extends Serenity.EntityGrid<StockReportRow, any> {
        protected getColumnsKey() { return 'Stock.StockReport'; } 
        protected getIdProperty() { return StockReportRow.idProperty; }
        protected getInsertPermission() { return StockReportRow.insertPermission; }
        protected getLocalTextPrefix() { return StockReportRow.localTextPrefix; }
        protected getService() { return StockReportService.baseUrl; }
        protected createQuickSearchInput() { }
        constructor(container: JQuery) {
            super(container);
            
        }
    } 
    //@Serenity.Decorators.registerClass()
    //export class ProductPerformanceGrid extends Serenity.EntityGrid<StockReportRow, any> {
    //    protected getColumnsKey() { return 'Stock.ProductPerformance'; }
    //    protected getDialogType() { return StockReportDialog; }
    //    protected getIdProperty() { return StockReportRow.idProperty; }
    //    protected getInsertPermission() { return StockReportRow.insertPermission; }
    //    protected getLocalTextPrefix() { return StockReportRow.localTextPrefix; }
    //    protected getService() { return ProductPerformanceService.baseUrl; }
    //    protected createQuickSearchInput() { }
    //    constructor(container: JQuery) {
    //        super(container);
    //        this.setTitle("Product Performance");
    //        this.addDateRangeFilter("VoucherDate", "Date"); 
    //    }
    //    protected getButtons(){ return [];}
    //}
}